import { useMutation } from "@tanstack/react-query";
import { useRefreshAlgoliaData } from "entities/algolia/hooks/useRefreshAlgoliaData";
import { invalidateImageFilesQueries } from "shared/queries/useImageFileQueries";
import { updateGameDetails } from "../api/updateGameDetails";
import { GameToUpdate } from "../types";
import { invalidateGameDetailsQuery } from "./useGameDetailsQuery";

type Params = {
  gameId: string;
  game: GameToUpdate;
};

const INITIAL_DELAY_MS = 2000;
const REFRESH_INTERVAL_MS = 5000;

export const useUpdateGameQuery = () => {
  const { refreshAlgoliaData } = useRefreshAlgoliaData();

  return useMutation({
    mutationFn: async ({ gameId, game }: Params) => {
      const gameData = {
        ...game,
        updatedAt: new Date(),
      };

      return await updateGameDetails(gameId, gameData);
    },
    onSuccess: (_, variables) => {
      // Invalidate query and refetch Algolia
      invalidateGameDetailsQuery(variables.gameId);
      invalidateImageFilesQueries([
        ["game-bg-image-file", variables.gameId],
        ["game-lg-image-file", variables.gameId],
      ]);
      refreshAlgoliaData(INITIAL_DELAY_MS);
      refreshAlgoliaData(REFRESH_INTERVAL_MS);
    },
    onError: (e) => console.error(e),
  });
};
